<template>
  <span class="btn-wrapper">
    <slot v-if="!disabled"></slot>
    <v-btn v-else disabled>{{ disabledButtonText }}</v-btn>
  </span>
</template>

<script>
export default {
  name: 'DisableableButton',
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      disabledButtonText: null,
    };
  },
  mounted() {
    this.disabledButtonText = this.$slots.default[0].componentOptions.propsData.label;
  },
};
</script>

<style>
.btn-wrapper button.v-btn.v-btn--disabled.v-btn--has-bg.theme--light,
.btn-wrapper button.v-btn.v-btn--disabled.v-btn--has-bg.theme--light:hover {
  color: white !important;
  background: grey !important;
  cursor: not-allowed;
}
</style>
